import React from "react";

export default function Collection({
  width = "50",
  height = "39",
  stroke = "#606f7b",
  fill = "#f8fafc"
}) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 50 39"
    >
      <g id="Canvas" fill="none">
        <g id="Vektor">
          <g id="Vector">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M 0.907881 11.3296L 0.908082 11.3296L 24.5751 21.4593L 24.5768 21.46C 24.7104 21.5184 24.8545 21.5468 25.0007 21.5468C 25.145 21.5468 25.2892 21.5173 25.4268 21.4591C 25.427 21.4591 25.4271 21.459 25.4272 21.459L 49.0927 11.3297M 49.7498 10.3119L 49.7498 10.3118C 49.7407 9.86991 49.4643 9.47882 49.0521 9.3225L 49.0519 9.32241L 25.3847 0.321153L 25.3845 0.32107C 25.1359 0.22628 24.8628 0.226366 24.6154 0.32099L 24.615 0.321153L 0.948597 9.32225L 0.948377 9.32233C 0.536411 9.47857 0.259912 9.87053 0.250227 10.3118C 0.24121 10.7525 0.501575 11.1561 0.907881 11.3296M 24.9999 2.49112L 25.0888 2.52492L 45.1983 10.173L 45.7767 10.393L 45.2078 10.6365L 25.0983 19.2441L 24.9999 19.2862L 24.9015 19.2441L 4.79171 10.6367L 4.22278 10.3932L 4.80121 10.1732L 24.911 2.52492L 24.9999 2.49112ZM 49.7498 10.3119C 49.759 10.7531 49.4992 11.1552 49.0929 11.3296Z"
              fill={fill}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M 0.907881 11.3296L 0.908082 11.3296L 24.5751 21.4593L 24.5768 21.46C 24.7104 21.5184 24.8545 21.5468 25.0007 21.5468C 25.145 21.5468 25.2892 21.5173 25.4268 21.4591C 25.427 21.4591 25.4271 21.459 25.4272 21.459L 49.0927 11.3297M 49.7498 10.3119L 49.7498 10.3118C 49.7407 9.86991 49.4643 9.47882 49.0521 9.3225L 49.0519 9.32241L 25.3847 0.321153L 25.3845 0.32107C 25.1359 0.22628 24.8628 0.226366 24.6154 0.32099L 24.615 0.321153L 0.948597 9.32225L 0.948377 9.32233C 0.536411 9.47857 0.259912 9.87053 0.250227 10.3118C 0.24121 10.7525 0.501575 11.1561 0.907881 11.3296M 24.9999 2.49112L 25.0888 2.52492L 45.1983 10.173L 45.7767 10.393L 45.2078 10.6365L 25.0983 19.2441L 24.9999 19.2862L 24.9015 19.2441L 4.79171 10.6367L 4.22278 10.3932L 4.80121 10.1732L 24.911 2.52492L 24.9999 2.49112ZM 49.7498 10.3119C 49.759 10.7531 49.4992 11.1552 49.0929 11.3296Z"
              strokeWidth="0.5"
              strokeMiterlimit="8"
              stroke={stroke}
            />
          </g>
          <g id="Vector_2">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M 0.907966 2.32883L 0.907982 2.32884L 24.9998 12.6408L 49.0911 2.32884L 49.0912 2.32881C 49.6417 2.09343 49.8961 1.45704 49.6607 0.907628L 49.6607 0.907555C 49.4258 0.358737 48.7916 0.101664 48.24 0.337978L 48.2399 0.338009L 25.0982 10.244L 24.9998 10.2861L 24.9014 10.244L 1.75888 0.33801L 1.75878 0.337966C 1.20909 0.102384 0.573156 0.358181 0.337581 0.907621C 0.10236 1.45755 0.357658 2.09333 0.907966 2.32883Z"
              transform="translate(0.00012207 14.7653)"
              fill={fill}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M 0.907966 2.32883L 0.907982 2.32884L 24.9998 12.6408L 49.0911 2.32884L 49.0912 2.32881C 49.6417 2.09343 49.8961 1.45704 49.6607 0.907628L 49.6607 0.907555C 49.4258 0.358737 48.7916 0.101664 48.24 0.337978L 48.2399 0.338009L 25.0982 10.244L 24.9998 10.2861L 24.9014 10.244L 1.75888 0.33801L 1.75878 0.337966C 1.20909 0.102384 0.573156 0.358181 0.337581 0.907621C 0.10236 1.45755 0.357658 2.09333 0.907966 2.32883Z"
              strokeWidth="0.5"
              strokeMiterlimit="8"
              transform="translate(0.00012207 14.7653)"
              stroke={stroke}
            />
          </g>
          <g id="Vector_3">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M 0.907966 2.32855L 0.907984 2.32856L 24.9998 12.6409L 49.0911 2.32856L 49.0912 2.32852C 49.6417 2.09312 49.8961 1.4575 49.6607 0.907798L 49.6607 0.907765C 49.4257 0.358796 48.7915 0.101509 48.2401 0.338126L 48.2399 0.338218L 25.0982 10.2442L 24.9998 10.2863L 24.9014 10.2442L 1.75888 0.338383L 1.75887 0.338379C 1.209 0.102986 0.573121 0.358522 0.337595 0.907962M 49.1895 2.55839C 49.867 2.26867 50.1802 1.48606 49.8905 0.8094ZM 0.907966 2.32855C 0.357572 2.09301 0.102419 1.45736 0.337561 0.908043ZM 49.8905 0.8094C 49.6016 0.134383 48.8208 -0.183136 48.1415 0.108389Z"
              transform="translate(0.00012207 20.0955)"
              fill={fill}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M 0.907966 2.32855L 0.907984 2.32856L 24.9998 12.6409L 49.0911 2.32856L 49.0912 2.32852C 49.6417 2.09312 49.8961 1.4575 49.6607 0.907798L 49.6607 0.907765C 49.4257 0.358796 48.7915 0.101509 48.2401 0.338126L 48.2399 0.338218L 25.0982 10.2442L 24.9998 10.2863L 24.9014 10.2442L 1.75888 0.338383L 1.75887 0.338379C 1.209 0.102986 0.573121 0.358522 0.337595 0.907962M 49.1895 2.55839C 49.867 2.26867 50.1802 1.48606 49.8905 0.8094ZM 0.907966 2.32855C 0.357572 2.09301 0.102419 1.45736 0.337561 0.908043ZM 49.8905 0.8094C 49.6016 0.134383 48.8208 -0.183136 48.1415 0.108389Z"
              strokeWidth="0.5"
              strokeMiterlimit="8"
              transform="translate(0.00012207 20.0955)"
              stroke={stroke}
            />
          </g>
          <g id="Vector_4">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M 49.8905 0.80875C 50.1802 1.48541 49.867 2.26802 49.1895 2.5579L 24.9998 12.9123L 25.0982 12.6825L 24.9998 12.6404L 49.0911 2.32807L 49.0912 2.32806C 49.6417 2.09249 49.8961 1.45684 49.6607 0.907149L 49.6607 0.907116C 49.426 0.358836 48.792 0.102395 48.2398 0.337609L 48.2399 0.337569L 48.1415 0.10774C 48.8208 -0.181812 49.6016 0.133734 49.8905 0.80875ZM 48.2396 0.337719L 48.1415 0.10774L 24.9998 10.0137L 1.85726 0.10774C 1.1801 -0.181976 0.39749 0.132911 0.107774 0.80875C -0.181942 1.48541 0.132617 2.26802 0.809607 2.5579M 0.908013 2.32809C 0.357581 2.0924 0.102424 1.45657 0.337552 0.90725ZM 48.2396 0.337719L 25.0982 10.2435L 24.9998 10.2856L 24.9014 10.2435L 1.75892 0.337587L 1.85725 0.107764L 1.75888 0.33757C 1.20898 0.102325 0.573112 0.357895 0.337595 0.907149M 0.908013 2.32809L 24.9998 12.6404L 24.9014 12.6825L 24.9998 12.9123"
              transform="translate(0.00012207 25.4265)"
              fill={fill}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M 49.8905 0.80875C 50.1802 1.48541 49.867 2.26802 49.1895 2.5579L 24.9998 12.9123L 25.0982 12.6825L 24.9998 12.6404L 49.0911 2.32807L 49.0912 2.32806C 49.6417 2.09249 49.8961 1.45684 49.6607 0.907149L 49.6607 0.907116C 49.426 0.358836 48.792 0.102395 48.2398 0.337609L 48.2399 0.337569L 48.1415 0.10774C 48.8208 -0.181812 49.6016 0.133734 49.8905 0.80875ZM 48.2396 0.337719L 48.1415 0.10774L 24.9998 10.0137L 1.85726 0.10774C 1.1801 -0.181976 0.39749 0.132911 0.107774 0.80875C -0.181942 1.48541 0.132617 2.26802 0.809607 2.5579M 0.908013 2.32809C 0.357581 2.0924 0.102424 1.45657 0.337552 0.90725ZM 48.2396 0.337719L 25.0982 10.2435L 24.9998 10.2856L 24.9014 10.2435L 1.75892 0.337587L 1.85725 0.107764L 1.75888 0.33757C 1.20898 0.102325 0.573112 0.357895 0.337595 0.907149M 0.908013 2.32809L 24.9998 12.6404L 24.9014 12.6825L 24.9998 12.9123"
              strokeWidth="0.5"
              strokeMiterlimit="8"
              transform="translate(0.00012207 25.4265)"
              stroke={stroke}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/Icons/Collection.js